// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { alertsClasses as myClasses } from "src/controllers/alerts";

import { HTMLDivProps, Radio, RadioGroup, Text } from "@blueprintjs/core";
import { Classes } from "src/mpd-library";

import { Select } from "src/components";

import "./styles.css";

export interface IExpiration extends HTMLDivProps {
  expiration: any;
  onExpirationSelectChanged(event: any, type: string): void;
  onRadioChanged(event: any, type: string): void;
}

export const Expiration: React.SFC<IExpiration> = props => {
  const {
    className,
    expiration,
    onExpirationSelectChanged,
    onRadioChanged
  } = props;

  const minutes = [];
  const hours = [];
  const days = [];

  for (let i = 0; i < 60; i++) {
    minutes.push(i.toString());
    if (i <= 30) {
      days.push(i.toString());
    }
    if (i <= 24) {
      hours.push(i.toString());
    }
  }

  const classes = classNames(
    myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER,
    "expiration-container",
    className
  );
  return (
    <div className={classes}>
      <Text className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE}>
        EXPIRATION
      </Text>
      <RadioGroup
        className="expiration-radio-container"
        name="expiration"
        onChange={event => onRadioChanged(event, "expiration")}
        selectedValue={expiration}
      >
        <Radio label="1 Hour" value="1-hour" />
        <Radio label="12 Hours" value="12-hours" />
        <Radio label="24 Hours" value="24-hours" />
        <Radio label="Custom" value="custom" />
      </RadioGroup>
      <div
        className={classNames(
          myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER,
          Classes.ROW,
          "expiration-custom-input",
          expiration === "custom" && Classes.ACTIVE
        )}
      >
        <Select
          className="compose-select"
          options={days}
          label="Days"
          selectable={false}
          onChange={e => onExpirationSelectChanged(e, "days")}
        />
        <Select
          className="compose-select"
          options={hours}
          label="Hours"
          onChange={e => onExpirationSelectChanged(e, "hours")}
          selectable={false}
        />
        <Select
          className="compose-select"
          options={minutes}
          label="Minutes"
          selectable={false}
          onChange={e => onExpirationSelectChanged(e, "minutes")}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/alert-details/expiration.tsx